var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20832_31825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00749 16.5C7.19058 16.5 6.38116 16.2619 5.74411 15.7933L2.52141 13.0182C1.66702 12.3858 1 11.0616 1 10.0127V4.86499C1 3.71934 1.84689 2.4993 2.93362 2.09758L6.67345 0.70644C7.41542 0.431187 8.58458 0.431187 9.32655 0.70644L13.0664 2.09758C14.1531 2.4993 15 3.71934 15 4.86499V10.0053C15 11.0616 14.333 12.3784 13.4786 13.0107L10.2559 15.7858C9.63383 16.2619 8.82441 16.5 8.00749 16.5Z",
    fill: "#00D180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5L7.24046 10.5L5 8.11624",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20832_31825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldProtected);
export default __webpack_public_path__ + "static/media/shield-protected.eadd8c09f44f7bcb9ee9d90e7f455818.svg";
export { ForwardRef as ReactComponent };